export class RDBreadcrumbElement {

  public name = '';
  public file = '';

  constructor() { }

}
